import './menu.css';
export default {
  "button": "pf-v6-c-button",
  "check": "pf-v6-c-check",
  "dirRtl": "pf-v6-m-dir-rtl",
  "divider": "pf-v6-c-divider",
  "menu": "pf-v6-c-menu",
  "menuBreadcrumb": "pf-v6-c-menu__breadcrumb",
  "menuContent": "pf-v6-c-menu__content",
  "menuFooter": "pf-v6-c-menu__footer",
  "menuGroup": "pf-v6-c-menu__group",
  "menuGroupTitle": "pf-v6-c-menu__group-title",
  "menuHeader": "pf-v6-c-menu__header",
  "menuItem": "pf-v6-c-menu__item",
  "menuItemAction": "pf-v6-c-menu__item-action",
  "menuItemActionIcon": "pf-v6-c-menu__item-action-icon",
  "menuItemCheck": "pf-v6-c-menu__item-check",
  "menuItemDescription": "pf-v6-c-menu__item-description",
  "menuItemExternalIcon": "pf-v6-c-menu__item-external-icon",
  "menuItemIcon": "pf-v6-c-menu__item-icon",
  "menuItemMain": "pf-v6-c-menu__item-main",
  "menuItemSelectIcon": "pf-v6-c-menu__item-select-icon",
  "menuItemText": "pf-v6-c-menu__item-text",
  "menuItemToggleIcon": "pf-v6-c-menu__item-toggle-icon",
  "menuList": "pf-v6-c-menu__list",
  "menuListItem": "pf-v6-c-menu__list-item",
  "menuSearch": "pf-v6-c-menu__search",
  "menuToggle": "pf-v6-c-menu-toggle",
  "modifiers": {
    "hidden": "pf-m-hidden",
    "hiddenOnSm": "pf-m-hidden-on-sm",
    "visibleOnSm": "pf-m-visible-on-sm",
    "hiddenOnMd": "pf-m-hidden-on-md",
    "visibleOnMd": "pf-m-visible-on-md",
    "hiddenOnLg": "pf-m-hidden-on-lg",
    "visibleOnLg": "pf-m-visible-on-lg",
    "hiddenOnXl": "pf-m-hidden-on-xl",
    "visibleOnXl": "pf-m-visible-on-xl",
    "hiddenOn_2xl": "pf-m-hidden-on-2xl",
    "visibleOn_2xl": "pf-m-visible-on-2xl",
    "disabled": "pf-m-disabled",
    "ariaDisabled": "pf-m-aria-disabled",
    "flyout": "pf-m-flyout",
    "top": "pf-m-top",
    "left": "pf-m-left",
    "drilldown": "pf-m-drilldown",
    "drilledIn": "pf-m-drilled-in",
    "currentPath": "pf-m-current-path",
    "static": "pf-m-static",
    "plain": "pf-m-plain",
    "scrollable": "pf-m-scrollable",
    "load": "pf-m-load",
    "loading": "pf-m-loading",
    "danger": "pf-m-danger",
    "focus": "pf-m-focus",
    "selected": "pf-m-selected",
    "favorited": "pf-m-favorited"
  }
};